import $ from 'jquery'

/**
 * Toggles the search filters in mobile with an Accordion effect.
 */
export default function mobileFilterAccordion () {
  const $filters = $('.js-search-filters')

  if (!$filters.length) {
    return
  }

  const $filtersContainer = $('.js-search-filters-container', $filters)
  const $filtersButtonToggler = $('.js-label', $filters)

  /**
   * State
   */
  let isCollapsed = false

  $filtersButtonToggler.on('click', function toggleFilters () {
    if (isCollapsed) {
      $filtersContainer.slideUp()
    } else {
      $filtersContainer.slideDown()
    }

    isCollapsed = !isCollapsed
  })
}
